import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  Divider,
  InputAdornment,
  Chip,
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import TranslateIcon from "@mui/icons-material/Translate";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import TagIcon from "@mui/icons-material/Tag";

export default function EditJobDialog({ open, onClose, job, onUpdate }) {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    nomFR: "",
    nomEN: "",
  });

  useEffect(() => {
    if (job) {
      setForm({
        nomFR: job.nomFR || "",
        nomEN: job.nomEN || "",
      });
    }
  }, [job, open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 4,
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        sx={{
          background: "linear-gradient(135deg, #ed6c02 0%, #e65100 100%)",
          color: "white",
          py: 3,
        }}
      >
        <Box display="flex" alignItems="center" gap={2}>
          <EditIcon sx={{ fontSize: 32 }} />

          <Box flex={1}>
            <Typography variant="h6" fontWeight={700}>
              Edit Job
            </Typography>

            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              Update existing job information
            </Typography>
          </Box>

          {job?.id && (
            <Chip
              icon={<TagIcon />}
              label={`ID : ${job.id}`}
              sx={{
                bgcolor: "rgba(255,255,255,0.2)",
                color: "white",
                fontWeight: 700,
              }}
            />
          )}
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 4 }}>
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
          Job Information
        </Typography>

        <Divider sx={{ mb: 3 }} />

        <TextField
          fullWidth
          label="Nom Français"
          value={form.nomFR}
          onChange={(e) =>
            setForm({
              ...form,
              nomFR: e.target.value,
            })
          }
          sx={{ mb: 3 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <TranslateIcon color="warning" />
              </InputAdornment>
            ),
          }}
        />

        <TextField
          fullWidth
          label="English Name"
          value={form.nomEN}
          onChange={(e) =>
            setForm({
              ...form,
              nomEN: e.target.value,
            })
          }
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <TranslateIcon color="warning" />
              </InputAdornment>
            ),
          }}
        />
      </DialogContent>

      <DialogActions
        sx={{
          px: 4,
          pb: 3,
          pt: 2,
          gap: 1,
        }}
      >
        <Button
          variant="outlined"
          color="inherit"
          startIcon={<CloseIcon />}
          onClick={onClose}
          sx={{
            borderRadius: 2,
            minWidth: 120,
          }}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          color="warning"
          startIcon={<SaveIcon />}
          disabled={loading || !form.nomFR || !form.nomEN}
          onClick={async () => {
            try {
              setLoading(true);
              await onUpdate(job, form);
            } finally {
              setLoading(false);
            }
          }}
          sx={{
            borderRadius: 2,
            minWidth: 120,
            fontWeight: 700,
            boxShadow: 3,
          }}
        >
          {loading ? "Updating..." : "Update"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
